// extracted by mini-css-extract-plugin
module.exports = {"container":"e_eob","pending":"e_fob","slider":"e_gob","imageContainer":"e_hob","image":"e_iob","button":"e_job","prevButton":"e_kob","nextButton":"e_lob","disabled":"e_mob"};